"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialogBody = void 0;
var _DialogBody = require("./DialogBody");
// TODO: in v9, move styled() from DialogBody.jsx to here
var StyledDialogBody = _DialogBody.DialogBody;
exports.StyledDialogBody = StyledDialogBody;